var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3358_32849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.625 2.25C7.625 2.74728 7.82254 3.22419 8.17417 3.57583C8.52581 3.92746 9.00272 4.125 9.5 4.125C9.99728 4.125 10.4742 3.92746 10.8258 3.57583C11.1775 3.22419 11.375 2.74728 11.375 2.25C11.375 1.75272 11.1775 1.27581 10.8258 0.924175C10.4742 0.572544 9.99728 0.375 9.5 0.375C9.00272 0.375 8.52581 0.572544 8.17417 0.924175C7.82254 1.27581 7.625 1.75272 7.625 2.25V2.25Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.625 9C7.625 9.49728 7.82254 9.97419 8.17417 10.3258C8.52581 10.6775 9.00272 10.875 9.5 10.875C9.99728 10.875 10.4742 10.6775 10.8258 10.3258C11.1775 9.97419 11.375 9.49728 11.375 9C11.375 8.50272 11.1775 8.02581 10.8258 7.67417C10.4742 7.32254 9.99728 7.125 9.5 7.125C9.00272 7.125 8.52581 7.32254 8.17417 7.67417C7.82254 8.02581 7.625 8.50272 7.625 9V9Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.625 15.75C7.625 16.2473 7.82254 16.7242 8.17417 17.0758C8.52581 17.4275 9.00272 17.625 9.5 17.625C9.99728 17.625 10.4742 17.4275 10.8258 17.0758C11.1775 16.7242 11.375 16.2473 11.375 15.75C11.375 15.2527 11.1775 14.7758 10.8258 14.4242C10.4742 14.0725 9.99728 13.875 9.5 13.875C9.00272 13.875 8.52581 14.0725 8.17417 14.4242C7.82254 14.7758 7.625 15.2527 7.625 15.75V15.75Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3358_32849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.df964e0bc572ae1a729a76eaccf862c9.svg";
export { ForwardRef as ReactComponent };